import { IEnvelope } from '@esri/arcgis-rest-types';

import { SnLonLatBounds } from '@lib/geo/helpers';

import { IQueryOptions } from '../tasks';

export function lonLatBoundsToArcGIS(
  lonLatBounds: SnLonLatBounds,
): Pick<IQueryOptions, 'geometry' | 'geometryType'> {
  return {
    geometry: {
      xmin: lonLatBounds.getSouthWest().lon,
      ymin: lonLatBounds.getSouthWest().lat,
      xmax: lonLatBounds.getNorthEast().lon,
      ymax: lonLatBounds.getNorthEast().lat,
      spatialReference: {
        wkid: 4326,
      },
    },
    geometryType: 'esriGeometryEnvelope',
  };
}

export function arcGISEnvelopeToLonLatBounds(envelope: IEnvelope): SnLonLatBounds {
  return new SnLonLatBounds([envelope.xmin, envelope.ymin], [envelope.xmax, envelope.ymax]);
}
